import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { History } from 'history'

import { createInsurancePolicy, rejectTask } from '../taskActions'
import { InputField, RadiobuttonGroup } from '../../../components/inputs'
import { InsurancePolicy } from '../types'
import { ReduxFormProps } from '../../../forms'
import { iso8601DateFormat } from '../../../helpers/timeHelper'

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('mm/dd/yyyy')

export type Callback<T = void> = (...args: any) => T

export interface Props {
  policy: InsurancePolicy
  createInsurancePolicy?: Callback<Promise<any>>
  rejectTask?: Callback<Promise<any>>
  history: History
}

export interface FormProps {
  companyName: string
  policyNumber: string
  phone: string
  fax: string
  agentName: string
  agentPhone: string
  effectiveDate: string
  expirationDate: string
  comprehensiveDeductible: string
  collisionDeductible: string
  collateralValidated: string
  listedAsLienholder: string
  customerLiable: string
  verified: string
}

export function formatInsurancePolicyData(values: InsurancePolicy) {
  const {
    collateralValidated,
    collisionDeductible,
    comprehensiveDeductible,
    customerLiable,
    effectiveDate,
    expirationDate,
    listedAsLienholder,
    verified,
  } = values
  const formatNumber = (n) => n && Number(n.replace(/[^0-9\.]+/g, ''))
  const formatBool = (b) => b === 'TRUE'

  return {
    ...values,
    collateralValidated: formatBool(collateralValidated),
    collisionDeductible: formatNumber(collisionDeductible),
    comprehensiveDeductible: formatNumber(comprehensiveDeductible),
    customerLiable: formatBool(customerLiable),
    effectiveDate: iso8601DateFormat(effectiveDate),
    expirationDate: iso8601DateFormat(expirationDate),
    listedAsLienholder: formatBool(listedAsLienholder),
    verified: formatBool(verified),
  }
}

export class InsurancePolicyInputs extends Component<
  ReduxFormProps<Props, FormProps>
> {
  createInsurancePolicy = (values) => {
    const { createInsurancePolicy, policy } = this.props

    return (
      createInsurancePolicy &&
      createInsurancePolicy(
        formatInsurancePolicyData({ ...values, ...policy })
      ).then(() => this.back())
    )
  }

  back = () => {
    const { history } = this.props
    history && history.goBack()
  }

  render() {
    const { policy, handleSubmit } = this.props
    if (!policy) return null

    const nullEmptyString = (value: string) => (value === '' ? null : value)
    const currencyInput = createNumberMask({
      allowDecimal: true,
      prefix: '$',
      decimalLimit: 2,
    })

    return (
      <form
        className="form"
        name="InsurancePolicyInputs"
        onSubmit={handleSubmit(this.createInsurancePolicy)}
      >
        <div className="task__insurance-policy">
          <Field<any> // TODO-TS
            label="Company Name"
            name="companyName"
            component={InputField}
            aria-required="true"
            gridClass="field"
          />

          <Field<any> // TODO-TS
            label="Policy Number"
            name="policyNumber"
            component={InputField}
            aria-required="true"
            gridClass="field"
          />

          <Field<any> // TODO-TS
            type="text"
            label="Effective Date"
            name="effectiveDate"
            format={(value) => (value === '' ? null : value)}
            component={InputField}
            placeholder="mm/dd/yyyy"
            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
            pipe={autoCorrectedDatePipe}
            normalize={nullEmptyString}
            keepCharPositions={true}
            gridClass="field"
          />

          <Field<any> // TODO-TS
            type="text"
            label="Expiration Date"
            name="expirationDate"
            format={(value) => (value === '' ? null : value)}
            component={InputField}
            placeholder="mm/dd/yyyy"
            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
            pipe={autoCorrectedDatePipe}
            normalize={nullEmptyString}
            keepCharPositions={true}
            gridClass="field"
          />

          <Field<any> // TODO-TS
            label="Comprehensive Deductible"
            name="comprehensiveDeductible"
            component={InputField}
            aria-required="true"
            gridClass="field"
            mask={currencyInput}
          />

          <Field<any> // TODO-TS
            label="Collision Deductible"
            name="collisionDeductible"
            component={InputField}
            aria-required="true"
            gridClass="field"
            mask={currencyInput}
          />

          <Field<any> // TODO-TS
            label="Phone Number"
            name="phone"
            component={InputField}
            aria-required="true"
            gridClass="field"
          />

          <Field<any> // TODO-TS
            label="Fax Number"
            name="fax"
            component={InputField}
            aria-required="true"
            gridClass="field"
          />

          <Field<any> // TODO-TS
            label="Agent Name"
            name="agentName"
            component={InputField}
            aria-required="true"
            gridClass="field"
          />

          <Field<any> // TODO-TS
            label="Agent Phone Number"
            name="agentPhone"
            component={InputField}
            aria-required="true"
            gridClass="field"
          />

          <div>
            <label className="form__label">Validated Collateral?</label>
            <br />
            <RadiobuttonGroup
              name="collateralValidated"
              value="TRUE"
              label="Yes"
              checked={policy.collateralValidated && 'TRUE'}
            />
            <RadiobuttonGroup
              name="collateralValidated"
              value="FALSE"
              label="No"
            />
          </div>

          <div>
            <label className="form__label">Listed As Lienholder?</label>
            <br />
            <RadiobuttonGroup
              name="listedAsLienholder"
              value="TRUE"
              label="Yes"
              checked={policy.listedAsLienholder && 'TRUE'}
            />
            <RadiobuttonGroup
              name="listedAsLienholder"
              value="FALSE"
              label="No"
            />
          </div>

          <div>
            <label className="form__label">Is Customer Liable?</label>
            <br />
            <RadiobuttonGroup
              name="customerLiable"
              value="TRUE"
              label="Yes"
              checked={policy.customerLiable && 'TRUE'}
            />
            <RadiobuttonGroup name="customerLiable" value="FALSE" label="No" />
          </div>

          <div>
            <label className="form__label">Verified?</label>
            <br />
            <RadiobuttonGroup
              name="verified"
              value="TRUE"
              label="Yes"
              checked={policy.verified && 'TRUE'}
            />
            <RadiobuttonGroup name="verified" value="FALSE" label="No" />
          </div>
        </div>

        <div className="task__insurance-policy__buttons">
          <button
            data-test="createInsurancePolicy"
            className="button button--primary"
          >
            Save
          </button>
          <button
            onClick={this.back}
            data-test="cancelButton"
            className="button button--link-text"
          >
            Cancel
          </button>
        </div>
      </form>
    )
  }
}

export const requiredFields: Partial<FormProps> = {
  companyName: 'Company Name is required',
  policyNumber: 'Policy Number is required',
  effectiveDate: 'Effective Date is required',
  expirationDate: 'Expiration Date is required',
  comprehensiveDeductible: 'Comprehensive Deductible is required',
  collisionDeductible: 'Collision Deductible is required',
  phone: 'Phone Number is required',
  fax: 'Fax Number is required',
  agentName: 'Agent Name is required',
  agentPhone: 'Agent Phone Number is required',
  collateralValidated: 'Please make a selection',
  listedAsLienholder: 'Please make a selection',
  customerLiable: 'Please make a selection',
  verified: 'Please make a selection',
}

export const validate = (policy: FormProps) => {
  const errors: Partial<FormProps> = Object.entries(requiredFields).reduce(
    (previous, [key, value]) => {
      if (!policy[key]) {
        previous[key] = value
      }
      return previous
    },
    {}
  )

  return errors
}

const mapDispatchToProps = (dispatch) => ({
  createInsurancePolicy: (values) => dispatch(createInsurancePolicy(values)),
  rejectTask: (id) => dispatch(rejectTask(id)),
})

const ConnectedInsurancePolicyInputs = connect(
  null,
  mapDispatchToProps
)(InsurancePolicyInputs)

export default withRouter(
  reduxForm<FormProps, Props>({
    form: 'insurancePolicyInputs',
    validate,
    enableReinitialize: false,
    destroyOnUnmount: true,
  })(ConnectedInsurancePolicyInputs)
)
